var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "td",
    { class: _vm.classes },
    [
      _vm.column.id === "operationDate"
        ? [
            _vm.view === "group-header"
              ? _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("svg-icon", {
                      staticClass: "operations-date__opener",
                      attrs: {
                        size: 24,
                        name: "chevron-top-circled",
                        color: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("toggle")
                        },
                      },
                    }),
                    _vm._v(" " + _vm._s(_vm.date.name) + " "),
                  ],
                  1
                )
              : _vm.view === "operation"
              ? [_vm._v(" " + _vm._s(_vm.item.date) + " ")]
              : _vm._e(),
          ]
        : _vm.column.id === "transactionDate"
        ? [
            _vm.view !== "group-header"
              ? [_vm._v(_vm._s(_vm.item.created))]
              : _vm._e(),
          ]
        : _vm.column.id === "balanceStart"
        ? [
            _vm.view !== "group-item"
              ? [_vm._v(_vm._s(_vm.item.dayStartBalance.toLocaleString()))]
              : _vm._e(),
          ]
        : _vm.column.id === "salary"
        ? [_vm._v(" " + _vm._s(_vm.item.salary.toLocaleString()) + " ")]
        : _vm.column.id === "dynamic"
        ? [_vm._v(" " + _vm._s(_vm.item.dynamic.toLocaleString()) + " ")]
        : _vm.column.id === "bonus"
        ? [_vm._v(" " + _vm._s(_vm.item.bonus.toLocaleString()) + " ")]
        : _vm.column.id === "penalty"
        ? [_vm._v(" " + _vm._s(_vm.item.penalty.toLocaleString()) + " ")]
        : _vm.column.id === "amount"
        ? [
            _c(
              "span",
              {
                class: {
                  "positive-number": _vm.item.amount > 0,
                  "negative-number": _vm.item.amount < 0,
                },
              },
              [_vm._v(" " + _vm._s(_vm.item.amount.toLocaleString()) + " ")]
            ),
          ]
        : _vm.column.id === "balanceEnd"
        ? [
            _vm.view !== "group-item"
              ? [_vm._v(_vm._s(_vm.item.dayEndBalance.toLocaleString()))]
              : _vm._e(),
          ]
        : _vm.column.id === "author"
        ? [
            _vm.view !== "group-header" && _vm.item.author
              ? [
                  _vm._v(" " + _vm._s(_vm.item.author) + " "),
                  _c("worker-or-user", {
                    attrs: {
                      value: _vm.item.author,
                      "without-link": !_vm.edit,
                    },
                  }),
                ]
              : _vm._e(),
          ]
        : _vm.column.id === "reason"
        ? [
            _vm.view !== "group-header" && _vm.item.reason
              ? [
                  _vm._v(" " + _vm._s(_vm.item.reason) + " "),
                  _vm.item.comment
                    ? _c(
                        "div",
                        { staticClass: "operation-comment" },
                        [
                          _c("svg-icon", {
                            staticClass: "operation-comment__icon",
                            attrs: { name: "comment" },
                          }),
                          _vm._v(" " + _vm._s(_vm.item.comment) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : _vm.column.id === "filial"
        ? [
            _vm.view !== "group-header" && _vm.item.filial_name
              ? [_vm._v(" " + _vm._s(_vm.item.filial_name) + " ")]
              : _vm._e(),
          ]
        : _vm.column.id === "removalAuthor"
        ? [
            _vm.view !== "group-header" && _vm.item.author
              ? [
                  _c("worker-or-user", {
                    attrs: {
                      value: _vm.item.removalAuthor,
                      "without-link": !_vm.edit,
                    },
                  }),
                ]
              : _vm._e(),
          ]
        : _vm.column.id === "removalDate"
        ? [
            _vm.view !== "group-header" && _vm.item.author
              ? [_vm._v(" " + _vm._s(_vm.item.removalDate) + " ")]
              : _vm._e(),
          ]
        : _vm.column.id === "removalComment"
        ? [
            _vm.view !== "group-header" && _vm.item.author
              ? [_vm._v(" " + _vm._s(_vm.item.removalComment) + " ")]
              : _vm._e(),
          ]
        : _vm.column.id === "actions"
        ? [
            _vm.operation
              ? [
                  _vm.operation.calculation
                    ? _c(
                        "router-link",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover blur",
                                content:
                                  "Сохраненный расчет по филиалу " +
                                  _vm.operation.calculation.filial +
                                  " за " +
                                  _vm.date.name,
                                placement: "top",
                              },
                              expression:
                                "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Сохраненный расчет по филиалу ' + operation.calculation.filial + ' за ' + date.name,\n          placement: 'top',\n        }",
                              modifiers: { html: true },
                            },
                          ],
                          attrs: {
                            target: "_blank",
                            to: {
                              name: "save-calculation-production",
                              query: {
                                calc_id: _vm.operation.calculation.id,
                              },
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: { size: 16, name: "calculator" },
                          }),
                        ],
                        1
                      )
                    : _vm.canRemove
                    ? [
                        _c("c-button", {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover blur",
                                boundary: "window",
                                content: "Удалить операцию",
                                placement: "top",
                              },
                              expression:
                                "{\n            container: '#app',\n            trigger: 'hover blur',\n            boundary: 'window',\n            content: 'Удалить операцию',\n            placement: 'top',\n          }",
                              modifiers: { html: true },
                            },
                          ],
                          attrs: {
                            size: "iconic",
                            icon: { icon: "trash", color: "secondary" },
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("remove")
                            },
                          },
                        }),
                      ]
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : _vm.column.id === "restore"
        ? [
            _vm.operation
              ? [
                  _c("c-button", {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.html",
                        value: {
                          container: "#app",
                          trigger: "hover blur",
                          boundary: "window",
                          content: "Восстановить операцию",
                          placement: "top",
                        },
                        expression:
                          "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Восстановить операцию',\n          placement: 'top',\n        }",
                        modifiers: { html: true },
                      },
                    ],
                    attrs: { size: "iconic", icon: { icon: "restore" } },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("restore")
                      },
                    },
                  }),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }